export default class Notifier {

    private isFirstCall: boolean;
    private container: any;
    private listener?: () => void;

    constructor(query: firebase.firestore.Query<firebase.firestore.DocumentData>, converter: (documentId: string, object: any) => any, callback: (value: any) => void) {
        this.container = [];
        this.isFirstCall = true;
        this.listener = query.onSnapshot(snapshot => {
            snapshot.docChanges().forEach((change) => {
                this.container[change.doc.id] = converter(change.doc.id, change.doc.data());
            });
            callback(this.container);
            this.isFirstCall = false;
        });
    }

    public stopListen() {
        if (this.listener === undefined) return;
        this.listener();
    }
}